













































































































































































































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {Action, Getter, State, Mutation} from 'vuex-class';
import BInput from 'buefy/src/components/input/Input.vue'; // @ is an alias to /src
import BField from 'buefy/src/components/field/Field.vue'; // @ is an alias to /src
import BDropdown from 'buefy/src/components/dropdown/Dropdown.vue';
import BDropdownItem from 'buefy/src/components/dropdown/DropdownItem.vue';
import BSelect from 'buefy/src/components/select/Select.vue';
import MAFDropdown from '../common/MAFDropdown.vue';

import {MAFUser} from '@/store/User/types';
import {LookupDistance, lookupIcon, LookupIcon} from '@/store/types'; // @ is an alias to /src

const namespace = 'userState';
@Component({
    components: {
        MAFDropdown,
        BDropdown,
        BDropdownItem,
        BSelect,
        BField,
        BButton,
        BInput,
    },
})

export default class ActivityInfo extends Vue {
    @Prop(MAFUser) public readonly self!: MAFUser;
    @Action('updateSelfDoc', {namespace}) public updateSelfDoc: any;
    @Getter('getFunStuff', {namespace}) public getFunStuff!: LookupIcon[];
    @Getter(`${namespace}/getGroupFunStuff`) public getGroupFunStuff!: LookupIcon[];

    // @Getter('getFirstHalfFun', {namespace}) getFirstHalfFun: LookupIcon[] | undefined;
    // @Getter('getSecondHalfFun', {namespace}) getSecondHalfFun: LookupIcon[] | undefined;
    @Getter('getDistances', {namespace}) public distances: LookupDistance[] | undefined;
    @Mutation('setSelf', {namespace: 'userState'}) public setSelf: any;



    public BASE_URL: string;
    public update: MAFUser;
    public isLoading: boolean;

    public interestOne: string;
    public interestTwo: string;
    public interestThree: string;
    public groupInterestOne: string;
    public groupInterestTwo: string;
    public groupInterestThree: string;
    public interestMessage: string;
    public groupInterestMessage: string;
    public distanceMessage: string;

    constructor() {
        super();
        this.isLoading = false;
        this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
        this.update = this.self;
        this.interestOne = '';
        this.interestThree = '';
        this.interestTwo = '';
        this.groupInterestOne = '';
        this.groupInterestThree = '';
        this.groupInterestTwo = '';
        this.distanceMessage = '';
        this.interestMessage = '';
        this.groupInterestMessage = '';
    }
    public clearError() {
        this.groupInterestMessage = '';
        this.interestMessage = '';
        this.distanceMessage = '';

    }

    public selectedInterest(selected: LookupIcon, type: number, num: number) {
        if (type === 1) {
            switch (num) {
                case 1:
                    this.interestOne = selected.display ? selected.display : '';
                    break;
                case 2:
                    this.interestTwo = selected.display ? selected.display : '';
                    break;
                case 3:
                    this.interestThree = selected.display ? selected.display : '';

                    break;
            }
        } else {
            switch (num) {
                case 1:
                    this.groupInterestOne = selected.display ? selected.display : '';
                    break;
                case 2:
                    this.groupInterestTwo = selected.display ? selected.display : '';
                    break;
                case 3:
                    this.groupInterestThree = selected.display ? selected.display : '';

                    break;
            }
        }
    }

    public selectedItem(selector: number) {
        switch (selector) {
            case 1:
                // @ts-ignore
                this.$refs.dropDownFirst.toggle();
                break;
            case 2:
                // @ts-ignore
                this.$refs.dropDownSecond.toggle();
                break;
            case 3:
                // @ts-ignore
                this.$refs.dropDownThird.toggle();
                break;
            case 4:
                // @ts-ignore
                this.$refs.dropDownFourth.toggle();
                break;
            case 5:
                // @ts-ignore
                this.$refs.dropDownFifth.toggle();
                break;
            case 6:
                // @ts-ignore
                this.$refs.dropDownSixth.toggle();
                break;
        }
    }

    public async submit(event: any) {
        event.preventDefault();
        this.clearError();
        let failed: boolean = false;
        this.isLoading = true;
        if (!this.groupInterestOne || !this.groupInterestTwo || !this.groupInterestThree) {
            failed = true;
            this.groupInterestMessage = 'Please select something you like to continue.';
        }
        if (!this.interestOne || !this.interestTwo || !this.interestThree) {
            failed = true;
            this.interestMessage = 'Please select something you like to continue.';
        }
        // if(!this.update.travelDistance){
        //     failed = true;
        //     this.distanceMessage = 'Please select a distance to continue.'
        // }
        if (failed) {
            this.isLoading = false;
            return;
        }
        this.update.interests = [this.interestOne, this.interestTwo, this.interestThree];
        this.update.groupInterests = [this.groupInterestOne, this.groupInterestTwo, this.groupInterestThree];
        this.update.signUpPhase = 4;

        try {
            await this.updateSelfDoc(this.update.toPlainObj());
            this.setSelf(this.update);
        } catch (error) {
            this.$snackbar.open({
                message: 'Error saving user please try again.',
                type: 'is-danger',
                indefinite: true,
            });
        }

        this.isLoading = false;
    }

}
